/**
 * Cloudflare Turnstile — constante pública del site key (SCRUM-183).
 *
 * Este archivo PUEDE estar en el bundle del cliente.
 * El site key es público (como cualquier API key de frontend).
 *
 * NUNCA incluir la clave secreta aquí ni en ningún VITE_* var.
 */

/**
 * Site key público de Cloudflare Turnstile.
 * Fuente: VITE_TURNSTILE_SITE_KEY (inyectado en build) con fallback al valor hardcodeado
 * para que funcione en SSR/server donde import.meta.env puede no estar disponible.
 */
export const TURNSTILE_SITE_KEY: string =
  (typeof import.meta !== "undefined" &&
    (import.meta as { env?: Record<string, string> }).env?.VITE_TURNSTILE_SITE_KEY) ||
  "0x4AAAAAAEdQRv75aqkfGvdZ";
